const AuthenticationIndicators = {
  NO_3DS: 'no_3ds',
  ASK_3DS: 'ask_3ds',
  FORCE_3DS: 'force_3ds',
};

module.exports = AuthenticationIndicators;
